import { useQuery } from '@hooks/reactQuery';

import { getVendorsByType } from '@api/networkElements';

import { extractQueryParams } from '@utils/common';
import { nameTitleToOptionFormatted } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { NETWORK_ELEMENTS_TYPE_OPTIONS } from '@constants/queryKeys';

interface IUseQueryVendorsByTypeParams {
	type: string;
}

interface IUseQueryVendorsByTypeReturned {
	vendorOptions: TSelectOption[];
	isLoadingVendorOptions: boolean;
}

const useQueryVendorsByType = (params?: IUseQueryVendorsByTypeParams): IUseQueryVendorsByTypeReturned => {
	const {
		data,
		isInitialLoading,
	} = useQuery({
		queryKey: [NETWORK_ELEMENTS_TYPE_OPTIONS, params],
		queryFn: extractQueryParams(getVendorsByType),
		select: nameTitleToOptionFormatted,
		allowedRoles: [EUserRoles.smoLightUpdater],
		...refetchOptions,
	});

	return {
		vendorOptions: data || [],
		isLoadingVendorOptions: isInitialLoading,
	};
};

export default useQueryVendorsByType;
